import * as React from 'react';
import { PageBackgroundContext } from '../hoc/withPageBasic';

export const usePageBackground = () => React.useContext(PageBackgroundContext);
